import classNames from "classnames";
import React, { FC } from "react";

type TableHeaderItem = {
  text: string | JSX.Element;
  style?: React.CSSProperties;
};

type TableHeadersProps = {
  headers: (string | TableHeaderItem)[];
};

const TableHeaders: FC<TableHeadersProps> = ({ headers }) => {
  return (
    <thead className={classNames("h-10", "leading-7")}>
      <tr
        className={classNames(
          "bg-black-lightest",
          "border-b-2",
          "border-gray-300",
          "border-l-3"
        )}
      >
        {headers.map((header, index) =>
          typeof header === "object" ? (
            <th
              key={`${header.text}-${index}`}
              className={classNames([
                "align-bottom",
                "text-left",
                "pb-1",
                "font-semibold",
              ])}
              style={header.style || {}}
            >
              {header.text}
            </th>
          ) : (
            <th
              key={`${header}-${index}`}
              className={classNames(
                "align-bottom",
                "text-left",
                "pb-1",
                "font-semibold"
              )}
            >
              {header}
            </th>
          )
        )}
      </tr>
    </thead>
  );
};

export default TableHeaders;
